import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'semantic-ui-react'
import { isDefined } from '../util/Common'

const ItemLink = (props) => (
    <Link to={ props.to } className={ props.active || false ? 'active item' : 'item' }>
        {
            isDefined(props.children) ? (
                props.children
            ) : (
                isDefined(props.icon) ? (
                    <Icon size='large' color='black' name={ props.icon }/>
                ) : (
                    <span className='black'>{ props.text }</span>
                )
            )
        }
    </Link>
)

export default ItemLink;


// WEBPACK FOOTER //
// ./src/components/ItemLink.js